export const ENTITY = 'ORGANIZATION_CATEGORY';

export const ORGANIZATION_CATEGORY_TYPE = {
   MINISTRY_AND_OFFICE: 'MINISTRY_AND_OFFICE',
   GOVERNMENT: 'GOVERNMENT'
}